export default __webpack_public_path__ + "static/media/login.0a97359cf56a63f519ae8f2a7f9201ee.svg";